/**
 * RESPONSIBILITY: the home page's ministry grid.
 *
 * The ministries come from the one Ministries list, which is edited in one place. This
 * band owns only the words around them.
 */
import { idOf } from '@framework/core';
import type { HomeMinistriesSection, Ministry } from '@app/sections';
import { MinistryCard } from '../ministries/MinistryCard';
import { Page, hrefFor } from '../commons/pages';

export function HomeMinistries(
  { c, ministries }: { c: HomeMinistriesSection; ministries: Ministry[] },
) {
  return (
    <section className="band band-tint">
      <div className="wrap">
        <div className="band-head">
          <div>
            {c.eyebrow && <span className="band-kicker">{c.eyebrow}</span>}
            <h2>{c.heading}</h2>
            {c.intro && <p className="lede">{c.intro}</p>}
          </div>
          {c.linkLabel && (
            <a className="btn btn-ghost" href={c.linkHref || hrefFor(Page.Ministry)}>{c.linkLabel}</a>
          )}
        </div>
        <div className="grid grid-3">
          {ministries.slice(0, c.count || 8).map((m) => <MinistryCard key={idOf(m)} m={m} />)}
        </div>
      </div>
    </section>
  );
}
